import gql from 'graphql-tag';

export const leaveWaitlistMutation = gql(/* GraphQL */ `
  mutation leaveWaitlist($enrollmentId: UUID!, $contentId: UUID!) {
    leaveWaitlist(enrollmentId: $enrollmentId, contentId: $contentId) {
      startDate
      endDate
    }
  }
`);
